import { Unit } from "./types";

import { CurriculumUnitsYearData } from "@/pages-helpers/curriculum/docx/tab-helpers";

// Note: Inefficient at the moment
export function findFirstMatchingFeatures(
  yearData: CurriculumUnitsYearData,
  fn: (unit: Unit) => boolean,
) {
  const features = Object.values(yearData)
    .flatMap((a) => a.units)
    .find(fn)?.features;
  return features;
}

export function getIsUnitDescriptionEnabled(unit?: Unit | null) {
  return unit?.parent_programme_features?.unit_description === true;
}

export function priorKnowledgeRequirementsEnabled(
  unit: Unit | Unit["unit_options"][number],
) {
  return (
    "parent_programme_features" in unit &&
    unit.parent_programme_features?.prior_knowledge_requirements
  );
}
